import { render, staticRenderFns } from "./PanelControls.vue?vue&type=template&id=50fc19cb&scoped=true&"
import script from "./PanelControls.vue?vue&type=script&lang=js&"
export * from "./PanelControls.vue?vue&type=script&lang=js&"
import style0 from "./PanelControls.vue?vue&type=style&index=0&id=50fc19cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fc19cb",
  null
  
)

export default component.exports